// AskBrunonButton: the loader draws no launcher and opens the chat beside it
export const ASSISTANT_ANCHOR_SELECTOR = '[data-ask-brunon]'

function assistantBase(assistantUrl: string): string {
  let base = assistantUrl.trim()
  while (base.endsWith('/')) {
    base = base.slice(0, -1)
  }
  return base
}

export function assistantWidgetSrc(assistantUrl: string): string {
  return `${assistantBase(assistantUrl)}/widget.js?persona=pro`
}

export function assistantAvatarSrc(assistantUrl: string): string {
  return `${assistantBase(assistantUrl)}/brands/laniqo/brunon-wink.png`
}
